import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMarketingInsiderPartnership from "@faire/web-api--source/routes/brand-portal/marketing/insider-partnership";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";

export const InsiderFreeShippingIA: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="The <ButtonFormatting>Insider Partnership</ButtonFormatting> is a program brands can join to fuel their growth by offering even more free shipping to Insiders (the top buyers on Faire) without covering all the costs themselves."
          description={{
            text: "The content of the Insider Free Shipping instant answer",
          }}
          values={{
            ButtonFormatting: (chunks: JSX.Element) =>
              InsiderPartnershipFormatting(chunks),
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="By offering more free shipping as an Insider Partner, you can:"
          description={{
            text: "The content of the Insider Free Shipping instant answer",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ul>
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Convert new customers:</BoldFormatting> Retailers are 30% more likely to buy when they see free shipping."
              description={{
                text: "The content of the Insider Free Shipping instant answer",
              }}
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
            />
          </Typography>
        </RowWithBullet>
        <Spacer height="1x" />
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Build loyalty with existing customers:</BoldFormatting> Retailers reorder 30% more when they get free shipping. They order more often and place larger orders."
              description={{
                text: "The content of the Insider Free Shipping instant answer",
              }}
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
            />
          </Typography>
        </RowWithBullet>
        <Spacer height="1x" />
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Get more exposure to top buyers on Faire:</BoldFormatting> Insiders drive 80% of Faire sales and order 2x more than non-Insiders. They primarily buy from brands with free shipping."
              description={{
                text: "The content of the Insider Free Shipping instant answer",
              }}
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
            />
          </Typography>
        </RowWithBullet>
      </ul>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="As a brand, you can choose to opt in and become an Insider Partner if you’d like to partner with Faire to expand the free shipping that Insiders see on your products. We’ll pay for free shipping on eligible marketplace Insider orders, and you’ll pay for free shipping on eligible Faire Direct Insider orders."
          description={{
            text: "The content of the Insider Free Shipping instant answer",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can visit the <ButtonFormatting>Insider Partnership page</ButtonFormatting> in your portal to see personalized estimates of what your brand’s free shipping coverage, sales, and costs could look like as an Insider Partner."
          values={{
            ButtonFormatting: (chunks: JSX.Element) =>
              InsiderPartnershipFormatting(chunks),
          }}
          description={{
            text: "The content of the Insider Free Shipping instant answer",
          }}
        />
      </Typography>
    </Column>
  );
};

const InsiderPartnershipFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalMarketingInsiderPartnership()}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
